import { useContext } from "react";
import QuickView from "../../../components/shared/quickview/QuickView";
import { mapResourceTypeToColumns } from "../../../components/shared/grid-bits/mapResourceTypeToColumns";
import GridContext from "../../../components/shared/grid-bits/context/GridContext";
import ImageDependentResourceIcon from "../../../components/shared/grid-bits/resources/ImageDependentResourceIcon";
import PublicImagesMenu from "./PublicImagesMenu";

const CustomizedRow = ({ resource }) => {
  const { resourceType } = useContext(GridContext);

  const Item = ({ item }) => {
    switch (item) {
      case "status":
        return <ImageDependentResourceIcon resource={resource} />;

      case "hamburger_menu":
        return <PublicImagesMenu resource={resource} />;

      case "id":
      case "name":
        return (
          <QuickView>
            <QuickView.Trigger>{resource[item]}</QuickView.Trigger>
            <QuickView.Content>
              <QuickView.Item>{`Image ID: ${resource.id}`}</QuickView.Item>
              <QuickView.Copy copy={resource.id}>Copy ID</QuickView.Copy>
              <QuickView.Copy copy={resource.name}>Copy Name</QuickView.Copy>
            </QuickView.Content>
          </QuickView>
        );

      case "size":
        return (
          <>
            {resource.sizeReadable ||
              `${Math.round(resource.size / 1024 / 1024 / 1024)} GB`}
          </>
        );

      case "min":
        return (
          <>
            {resource.min_ram}/{resource.min_disk}
          </>
        );

      default:
        return <>{resource[item]}</>;
    }
  };

  const columns = mapResourceTypeToColumns[resourceType];

  return (
    <>
      {columns.map((col) => (
        <div className="grid__cell" key={col.name}>
          <Item item={col.name} />
        </div>
      ))}
    </>
  );
};

export default CustomizedRow;
